module.exports = __webpack_public_path__ + "media/images/design/images/bn_pr01-d116fe7abc07688d2f3a72e35b3c595b.jpg";